// 历史记录
<template>
  <div class="history">
    <van-nav-bar :title="$t('menu.history')" @click-left="$router.go(-1)" left-arrow fixed placeholder z-index="5" />
    <section class="list-container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('tips.noMore')"
          :offset="100"
          @load="onLoad"
        >
          <div class="van-clearfix" v-if="list.length">
            <div class="card" v-for="item in list" :key="item.id" @click="linkToDetail(item)">
              <van-swipe-cell>
                <div class="card-item flex justify-between">
                  <div class="left">
                    <div class="desc flex align-center">Factory：<span>{{item.nameEn}}</span></div>
                    <div class="desc flex align-center">Brand：<span>{{item.brandNameEn}}</span></div>
                    <div class="desc flex align-center">Taste：<span>{{item.tasteNameEn}}</span></div>
                    <div class="desc flex align-center">Product Series：<span>{{item.seriesNameEn}}</span></div>
                  </div>
                  <div class="right flex justify-between align-center">
                    <div class="flex align-center"><img :src="item.picture" /></div>
                    <van-icon size="22" name="like" :color="item.isLike ? '#FF6363' : '#CECECE'" @click.prevent="editLike(item)" />
                  </div>
                </div>
                <template #right>
                  <div class="swipe flex align-center">
                    <van-icon
                      size="25"
                      :name="require('@/assets/images/icon/operation_a.png')"
                      @click.prevent.stop="recover(item)"
                    />
                  </div>
                </template>
              </van-swipe-cell>
            </div>
          </div>
          <div v-else>
            <van-empty :description="$t('message.noData')" />
          </div>
        </van-list>
      </van-pull-refresh>
    </section>
  </div>
</template>

<script>
import { getAllEuipmentList, hideEuipment } from '@/api'
export default {
  name: 'Favorite',
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      pagination: {
        page: 1,
        size: 10,
        total: 1
      },
      list: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化列表
    async init () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true
      })
      await getAllEuipmentList({
        pageNum: this.pagination.page,
        pageSize: this.pagination.size
      }).then(res => {
        if (res.code === 200) {
          this.loading = false
          this.list = [...this.list, ...res.data]
          this.pagination.page += 1
        }
      }).finally(() => {
        this.$toast.clear()
      })
    },
    // 底部加载
    onLoad () {
      this.loading = true
      if (this.list.length >= this.pagination.total) {
        this.finished = true
      } else {
        setTimeout(() => {
          this.init()
        }, 1000)
      }
    },
    // 下拉刷新
    onRefresh () {
      // 清空列表数据
      this.finished = false
      this.refreshing = true

      if (this.refreshing) {
        this._clearParams()
        this.refreshing = false
        this.loading = false
      }
      this.init()
    },
    // 清除筛选重置刷新
    _clearParams () {
      this.filter = {
        searchKey: 'code',
        searchVal: ''
      }
      this.pagination.page = 1
      this.list = []
    },
    // 恢复
    recover (item) {
      hideEuipment({ id: item.id, isRemove: 0 }).then((res) => {
        this.$toast(res.msg)
        this.pagination.page = 1
        this.list = []
        this.init()
      })
    }
  }
}
</script>

<style lang="less">
  .history {
    .van-hairline--bottom {
      &:after {
        border-bottom-width: 0;
      }
    }
    .list-container {
      box-sizing: border-box;
      padding: 30px 0;
      height: calc(~"100vh - 100px");
    }
    .card {
      padding: 0 24px 24px;
      .card-item {
        background: #fff;
        padding: 30px;
        border-radius: 15px;
        box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.2);
      }
      .van-swipe-cell {
        overflow: inherit;
        .swipe {
          box-sizing: border-box;
          height: 100%;
          padding: 20px;
          i {
            padding: 20px;
          }
        }
      }
      .left {
        width: 65%;
        .connect {
          font-size: 22px;
          .connect-point {
            display: block;
            width: 15px;
            height: 15px;
            background: #CECECE;
            border-radius: 50%;
            margin-right: 9px;
          }
        }
        .desc {
          width: 100%;
          font-size: 20px;
          white-space: nowrap;
          line-height: 1.8;
          span {
            white-space: pre-wrap;
            word-wrap: break-word;
            font-weight: bold;
            line-height: 1.2;
          }
        }
        .step-container {
          margin: 20px 0 10px;
          position: relative;
          width: 100%;
          height: 44px;
          border-radius: 22px;
          background: #C1C1C1;
          overflow: hidden;
          span {
            position: absolute;
            top: 0;
            left: 0;
            height: inherit;
            border-radius: 22px;
            background: linear-gradient(90deg, #3EE191, #24DEDD);
          }
        }
      }
      .right {
        width: 35%;
        img {
          width: 140px;
          height: 140px;
          object-fit: contain;
        }
      }
      .login-content {
        padding: 30px 40px;
        font-size: 22px;
        text-align: center;
        font-weight: bold;
        line-height: 1.5;
        .btn1, .btn2 {
          font-weight: normal;
          margin-top: 20px;
          width: 150px;
          height: 60px;
          line-height: 60px;
          color: #fff;
          border-radius: 16px;
        }
        .btn1 {
          background: #C1C1C1;
        }
        .btn2 {
          margin-left: 40px;
          background: linear-gradient(30deg, #3EE191, #24DEDD);
        }
      }
    }
  }
</style>
